import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { toast } from "react-toastify";
import FilterService from "../../services/FilterService";
import CustomerService from "../../services/CustomerService";
import CustomerFilterService from "../../services/CustomerFilterService";
import "./AddCustomerFilter.css";

const AddCustomerFilterModal = ({ showModal, handleClose, onCustomerFilterAdded }) => {
  const [formData, setFormData] = useState({
    customer_id: "",
    filter_id: "",
    date_of_installation: "",
    date_to_be_changed: "",
  });

  const [filters, setFilters] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [selectedFilterDuration, setSelectedFilterDuration] = useState(0);

  // Load filters and customers
  useEffect(() => {
    const loadFiltersAndCustomers = async () => {
      try {
        const filtersResponse = await FilterService.getAll();
        const customersResponse = await CustomerService.getAll();

        console.log("Filters Response:", filtersResponse.data);
        console.log("Customers Response:", customersResponse.data);

        setFilters(filtersResponse.data.filters || []);
        setCustomers(customersResponse.data || []);
      } catch (error) {
        console.error("Failed to load filters or customers:", error);
        toast.error("Failed to load data");
      }
    };

    loadFiltersAndCustomers();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    if (name === "filter_id") {
      const selectedFilter = filters.find((f) => f.ID === parseInt(value));
      if (selectedFilter) {
        setSelectedFilterDuration(parseInt(selectedFilter["Lasting Duration (Months)"]));
      }
    }

    if (name === "date_of_installation" && selectedFilterDuration > 0) {
      calculateChangeDate(value, selectedFilterDuration);
    }
  };

  const calculateChangeDate = (installationDate, duration) => {
    if (installationDate && duration) {
      const date = new Date(installationDate);
      date.setMonth(date.getMonth() + duration);
      const formattedDate = date.toISOString().split("T")[0];
      setFormData((prevData) => ({ ...prevData, date_to_be_changed: formattedDate }));
    }
  };

  const saveCustomerFilter = async () => {
    try {
      const payload = {
        customer_id: formData.customer_id,
        filter_id: formData.filter_id,
        date_of_installation: formData.date_of_installation,
        date_to_be_changed: formData.date_to_be_changed,
      };

      await CustomerFilterService.create(payload);
      toast.success("Customer Filter added successfully", { autoClose: 2000 });

      setFormData({
        customer_id: "",
        filter_id: "",
        date_of_installation: "",
        date_to_be_changed: "",
      });
      handleClose();
      onCustomerFilterAdded();
    } catch (error) {
      console.error("Failed to add customer filter:", error);
      toast.error("Failed to add customer filter");
    }
  };

  return (
    <Modal show={showModal} onHide={handleClose} className="add-customer-filter-modal">
      <Modal.Header closeButton>
        <Modal.Title>Add Customer Filter</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form>
          <div className="form-group">
            <label>Customer</label>
            <select
              name="customer_id"
              value={formData.customer_id}
              onChange={handleInputChange}
              required
            >
              <option value="">Select Customer</option>
              {customers.map((customer) => (
                <option key={customer.ID} value={customer.ID}>
                  {customer["First Name"]} {customer["Last Name"]}
                </option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label>Filter</label>
            <select
              name="filter_id"
              value={formData.filter_id}
              onChange={handleInputChange}
              required
            >
              <option value="">Select Filter</option>
              {filters.map((filter) => (
                <option key={filter.ID} value={filter.ID}>
                  {filter["Filter Name"]}
                </option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label>Date of Installation</label>
            <input
              type="date"
              name="date_of_installation"
              value={formData.date_of_installation}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Date to be Changed</label>
            <input
              type="date"
              name="date_to_be_changed"
              value={formData.date_to_be_changed}
              readOnly
            />
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <div className="d-flex justify-content-end w-100">
          <Button variant="primary" onClick={saveCustomerFilter} className="w-100">
            Save
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default AddCustomerFilterModal;
